import tmhRequest from '@/config/tmhRequest'

export default {

    searchPlatformEmployee: function (data) {
        return tmhRequest({
            url: '/hr/tmh/platformemployee/searchplatformemployee',
            method: 'post',
            params: data,
        })
    },

    searchListPlatformEmployee: function (data) {
        return tmhRequest({
            url: '/hr/tmh/platformemployee/searchlistplatformemployee',
            method: 'post',
            params: data,
        })
    },

    searchPlatformEmployeeCount: function (data) {
        return tmhRequest({
            url: '/hr/tmh/platformemployee/searchplatformemployeecount',
            method: 'post',
            data: data,
        })
    },

    searchPlatformEmployeeByPage: function (data) {
        return tmhRequest({
            url: '/hr/tmh/platformemployee/searchplatformemployeebypage',
            method: 'post',
            data: data,
        })
    },


    initPlatformEmployee: function (data) {
        return tmhRequest({
            url: '/hr/tmh/platformemployee/initplatformemployee',
            method: 'post',
            params: data,
        })
    },

    addPlatformEmployee: function (data) {
        return tmhRequest({
            url: '/hr/tmh/platformemployee/addplatformemployee',
            method: 'post',
            data: data,
        })
    },

    editPlatformEmployee: function (data) {
        return tmhRequest({
            url: '/hr/tmh/platformemployee/editplatformemployee',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/hr/platformemployee.js